import { ApiService, CliaCertificate } from "pwapi";

import { CliaCertificateOption } from "../edit/ResourceOptions";
import SelectSearchInput from "../edit/SelectSearchInput";

const mapCertsToOptions = (certs: CliaCertificate[]) => {
  return [
    {
      value: "",
      label: "All TC CLIAs",
      object: { name: "All TC CLIA Certificates" },
    },
    ...certs
      .filter((cert) => cert.id && cert.name && cert.number)
      .map((cert) => ({
        value: `${cert.name} - ${cert.number},${cert.id}`,
        label: cert.name,
        object: cert,
      })),
  ];
};

const TCCliaCertificateFilter = ({
  onChange,
  value,
}: {
  onChange: Function;
  value?: string;
}) => {
  const label = value?.match(/(.*),(\d*)$/)?.[1] || undefined;

  return (
    <SelectSearchInput
      label="TC CLIA Certificate"
      field="grossedByCert"
      filter="name"
      onChange={onChange}
      serviceOptions={{
        hasLabId: true,
      }}
      mapToOptions={mapCertsToOptions}
      apiService={ApiService.listCliaCertificates}
      component={CliaCertificateOption}
    >
      {label ? label : "All TC CLIA Certficates"}
    </SelectSearchInput>
  );
};

export default TCCliaCertificateFilter;
